var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSections(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 9.16602H6.66683M8.3335 12.4993H6.66683M13.3335 5.83268H6.66683M16.6668 5.66602V14.3327C16.6668 15.7328 16.6668 16.4329 16.3943 16.9677C16.1547 17.4381 15.7722 17.8205 15.3018 18.0602C14.767 18.3327 14.067 18.3327 12.6668 18.3327H7.3335C5.93336 18.3327 5.2333 18.3327 4.69852 18.0602C4.22811 17.8205 3.84566 17.4381 3.60598 16.9677C3.3335 16.4329 3.3335 15.7328 3.3335 14.3327V5.66602C3.3335 4.26588 3.3335 3.56582 3.60598 3.03104C3.84566 2.56063 4.22811 2.17818 4.69852 1.9385C5.2333 1.66602 5.93336 1.66602 7.3335 1.66602H12.6668C14.067 1.66602 14.767 1.66602 15.3018 1.9385C15.7722 2.17818 16.1547 2.56063 16.3943 3.03104C16.6668 3.56582 16.6668 4.26588 16.6668 5.66602Z",
    stroke: "#475467",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSections);
export default __webpack_public_path__ + "static/media/sections.293eb606509f371b3c83356bef514c30.svg";
export { ForwardRef as ReactComponent };